/* fail-safe */try{
/* Proactive Coaching — collapsible grids.
 *
 * Any element with data-collapse="N" keeps its first N children visible and
 * hides the rest behind a "Show all X" button (which flips to "Show fewer").
 * Progressive enhancement: without JS, everything simply shows.
 * Grids barely over the limit (≤2 extra) are left uncollapsed — a button that
 * reveals one card is noise.
 */
(function () {
    document.querySelectorAll('[data-collapse]').forEach(function (grid) {
        var max = parseInt(grid.getAttribute('data-collapse'), 10) || 6;
        var items = Array.prototype.slice.call(grid.children);
        if (items.length <= max + 2) return;

        var hidden = items.slice(max);
        hidden.forEach(function (el) { el.classList.add('pc-collapsed'); });

        var noun = grid.getAttribute('data-collapse-noun') || 'items';
        // Reveal in batches (Baymard: load-more beats show-all / infinite scroll)
        var BATCH = 24;
        var shown = max;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pcp-showall';
        function render() {
            items.forEach(function (el, i) { el.classList.toggle('pc-collapsed', i >= shown); });
            var left = items.length - shown;
            if (left > 0) {
                btn.innerHTML = 'Show ' + Math.min(BATCH, left) + ' more ' + noun +
                    ' (' + left + ' left) <span class="pc-arrow" aria-hidden="true">&darr;</span>';
                btn.setAttribute('aria-expanded', 'false');
            } else {
                btn.innerHTML = 'Show fewer <span class="pc-arrow" aria-hidden="true">&uarr;</span>';
                btn.setAttribute('aria-expanded', 'true');
            }
        }
        render();
        btn.addEventListener('click', function () {
            if (shown >= items.length) {
                shown = max;
                grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
            } else {
                shown = Math.min(shown + BATCH, items.length);
            }
            render();
        });
        grid.parentNode.insertBefore(btn, grid.nextSibling);
    });
})();
}catch(e){/* never halt the bundle */}
